import React from 'react'

import { ExampleWrapperSeamless } from '@/layout-components'

import ResetPassword from '@/housefolios-components/SignIn/ResetPassword'

import { Grid } from '@mui/material'

export default function ResetPasswordPage() {
  return (
    <>
      <ExampleWrapperSeamless>
        <Grid
          container
          sx={{
            justifyContent: 'center',
          }}
        >
          <Grid size={12} sx={{ display: 'flex' }}>
            <ResetPassword />
          </Grid>
        </Grid>
      </ExampleWrapperSeamless>
    </>
  )
}
